<template>
  <div class="search-data">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :inline="true">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">选择定位点</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" title="热门搜索" @on-ok="ok">
      <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table
        border
        :columns="columns2"
        ref="selection"
        :data="list"
        :loading="dataloading"
        @on-selection-change="handleSelectRow()"
      ></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page
            ref="listPage1"
            :total="pages1.total"
            :current="pages1.page"
            :page-size="pages1.size"
            show-elevator
            show-total
            @on-change="changePage1()"
          ></Page>
        </div>
      </div>
    </Modal>
    <!--设置资讯数量-->
    <Modal v-model="zixunStatus" title="设置" @on-ok="updateZixun()" :loading="loading">
      <Form :model="zixunModel" :label-width="150">
        <FormItem label="资讯数量：" label-position="top">
          <Input v-model="zixunModel.zixun_num"></Input>
        </FormItem>
        <FormItem label="定位点自动播放" label-position="top">
          <RadioGroup v-model="zixunModel.is_free">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "search-data",
  data() {
    return {
      title: "选择定位点",
      loading: true,
      dataloading: true,
      zixunStatus: false,
      zixunModel: {
        zixun_num: 0,
        is_free: 0
      },
      search_s: {
        //搜索商品等
        key: ""
      },
      columns: [
        {
          title: "项目名称",
          key: "itemname",
          minWidth: 200
        },
        {
          title: "分类",
          key: "catename",
          minWidth: 200
        },
        {
          title: "等级",
          key: "levelname",
          minWidth: 200
        },
        {
          title: "地区",
          key: "areaname",
          minWidth: 200
        },
        {
          title: "经度",
          key: "lat",
          minWidth: 200
        },
        {
          title: "纬度",
          key: "lng",
          minWidth: 200
        },
        {
          title: "资讯数量",
          key: "zixun_num",
          minWidth: 200
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.location_id);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showZixun(params.row.location_id);
                    }
                  }
                },
                "设置"
              )
            ]);
          }
        }
      ],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "#",
          key: "location_id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "title",
          fixed: "left"
        },
        {
          title: "地区",
          key: "areaname",
          fixed: "left"
        }
      ],
      tablelist: [],
      tablelist1: [],
      list: [],
      type: "1", //搜索类型1商品2约看
      search: {
        name: "",
        sort: 0
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      pages1: {
        page: 1,
        size: 15,
        total: 0
      },
      showModalStatus: false
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.bigmap.hotLocations(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    //展开选择
    showModel() {
      this.search_s.key = "";
      this.showModalStatus = true;
      this.tablelist1 = [];
      this.selected = [];
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.bigmap.hotLocations(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage1() {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    // 筛选
    renderTable1: function(name) {
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size
      };
      this.$api.bigmap.allLocations(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.list = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow(selection, index) {
      this.selected = this.$refs.selection.getSelection();
    },
    //选中提交
    ok() {
      this.tablelist1 = this.selected;
      this.$api.bigmap
        .posthotlocation({ location_ids: this.tablelist1 })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.getTableList();
          }
        });
    },
    showZixun(id) {
      this.location_id = id;
      this.zixunStatus = !this.zixunStatus;
      this.zixunModel.zixun_num = "";
      this.zixunModel.is_free = 0;
      this.$api.bigmap.getZixun({ location_id: id }).then(res => {
        if (res.code == 200 && res.result != []) {
          this.zixunModel = res.result;
        }
      });
    },
    updateZixun() {
      this.$api.bigmap
        .postZixun({
          location_id: this.location_id,
          zixun_num: this.zixunModel.zixun_num,
          is_free: this.zixunModel.is_free
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.renderTable(1);
            this.zixunStatus = false;
          } else {
            this.$Message.success(res.msg);
          }
        });
    },

    // 删除
    remove: function(id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.bigmap.remove({ location_id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
